import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from '../../data/ui';

const IMAGE_SIZE = 400;

export const useStyles = makeStyles(
  (theme) => ({
    imageWrapper: {
      borderRadius: theme.shape.borderRadiusMedium,
      backgroundColor: COLORS.gray.gray80,
      width: IMAGE_SIZE,
      flexShrink: 0,
      marginRight: theme.spacing(4),
      display: 'flex',
      justifyContent: 'center',
      overflow: 'hidden',
      flexDirection: 'column',
    },
    imageEditWrapper: {
      position: 'relative',
      maxHeight: IMAGE_SIZE,
      maxWidth: IMAGE_SIZE,
      overflow: 'hidden',
      margin: 'auto',
    },
    image: {
      objectFit: 'contain',
      maxHeight: IMAGE_SIZE,
      maxWidth: IMAGE_SIZE,
    },
  }),
  { name: 'ImageBox' }
);
